import { Button } from '@/components/ui/button'
import React from 'react'

interface SignInSubmitButtonProps {
  text: string
  onClick?: () => void
}

export default function SignInSubmitButton({
  text,
  onClick,
}: SignInSubmitButtonProps) {
  return (
    <Button
      className="w-full bg-primary uppercase text-white px-7 py-3 text-sm font-medium rounded shadow-md hover:bg-[#01589d] transition duration-150 ease-in-out hover:shadow-lg active:bg-primary mb-3"
      onClick={onClick}
      type="submit"
    >
      {text}
    </Button>
  )
}
